import { useState } from "react";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { FiX } from "react-icons/fi";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import { FormProvider, useForm } from "react-hook-form";
import {
  FormInput,
  FormSelect,
} from "../../../../Components/Forms/InputTemplate";
import { useHrCreateRatingsMutation } from "../../../../../api/hrApi";
import { toast } from "react-hot-toast";

const levelOptions = Array.from({ length: 10 }, (_, i) => ({
  value: (i + 1).toString(),
  label: (i + 1).toString(),
}));

const colorOptions = [
  { value: 0, label: "Red" },
  { value: 1, label: "Yellow" },
  { value: 2, label: "Blue" },
  { value: 3, label: "Black" },
  { value: 4, label: "White" },
  { value: 5, label: "Green" },
];
const RatingScaleModal = ({
  setIsOpen,
  isOpen,
  isLoading,
  onValidate = () => {},
}) => {
  const [onCreate] = useHrCreateRatingsMutation();
  const [levels, setLevels] = useState(1);

  const formMethods = useForm({
    mode: "all",
    defaultValues: {
      title: "",
      scaleLevel: 1,
      scaleLevels: [
        {
          scaleNumber: 1,
          scaleTitle: "",
          scaleDescription: "",
          colorType: 0,
        },
      ],
    },
  });

  const {
    handleSubmit,
    formState: { isValid },
    setValue,
    watch,
  } = formMethods;
  const scaleLevels = watch("scaleLevels");
  const scaleLevel = watch("scaleLevel");
  const handleLevelsChange = (e) => {
    const newLevel = Number(e.target.value);
    setLevels(newLevel);
    setValue("scaleLevel", newLevel);
    const updatedLevels = Array.from({ length: newLevel }, (_, i) => {
      return (
        scaleLevels?.[i] || {
          scaleNumber: i + 1,
          scaleTitle: "",
          scaleDescription: "",
          colorType: 0,
        }
      );
    });
    setValue("scaleLevels", updatedLevels);
  };

  const submit = async (data) => {
    const payload = {
      title: data.title,
      scaleLevel: Number(data.scaleLevel),
      scaleLevels: data.scaleLevels.map((level, idx) => ({
        scaleNumber: Number(level.scaleNumber ?? idx + 1),
        scaleTitle: level.scaleTitle?.trim?.() ?? "",
        scaleDescription: level.scaleDescription?.trim?.() ?? "",
        colorType: Number(level.colorType),
      })),
    };
    try {
         const response = await onCreate(payload).unwrap();
         if (response?.successful) {
           setIsOpen(false);
           onValidate();
           toast.success(response?.statusMessage);
         }
       } catch (err) {
         toast.error(err?.data?.statusMessage);
       }
  };

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Set Up </h4>
          <h1 className="text-[28px] font-[800]">Rating Scale</h1>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <form onSubmit={handleSubmit(submit)} className="space-y-6">
              <FormInput
                camelCase="title"
                title="Title"
                placeholder="Enter rating scale title"
              />
              <FormSelect
                camelCase="scaleLevel"
                title="Number of Levels"
                array={levelOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
                defaultValue={levels}
                moreRegister={{
                  onChange: handleLevelsChange,
                }}
              />
              {Array.from({ length: Number(scaleLevel) || 1 }).map((_, idx) => (
                <div
                  key={idx}
                  className="border rounded p-3 mb-2 bg-gray-50 flex flex-col gap-2"
                >
                  <div className="font-semibold text-sm mb-1">
                    Level {idx + 1}
                  </div>
                  <FormInput
                    camelCase={`scaleLevels.${idx}.scaleNumber`}
                    title="Scale Number"
                    type="number"
                    defaultValue={idx + 1}
                  />
                  <FormInput
                    camelCase={`scaleLevels.${idx}.scaleTitle`}
                    title="Scale Title"
                    placeholder="Enter scale title"
                  />
                  <FormInput
                    camelCase={`scaleLevels.${idx}.scaleDescription`}
                    title="Scale Description"
                    placeholder="Enter scale description"
                  />
                  <FormSelect
                    camelCase={`scaleLevels.${idx}.colorType`}
                    title="Color"
                    array={colorOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                    defaultValue={0}
                  />
                </div>
              ))}
              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid}
                  width={"auto"}
                  type={"submit"}
                  // onClick={onValidate}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  Submit
                </ActionButtons>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default RatingScaleModal;
